var React = require('react');

function ShopCart (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2"},[React.createElement("path",{"stroke":"#FFFFFF","d":"M9.333 20.998h0c4.603 0 8.334.218 8.334-4.346V6H1v10.652c0 4.564 3.73 4.346 8.333 4.346Z","key":0}),React.createElement("path",{"stroke":"#FFF","d":"M6 6V4.567C6 2.597 7.493 1 9.333 1s3.334 1.596 3.334 3.567V6","key":1})]));
}

ShopCart.defaultProps = {"width":"19","height":"22","viewBox":"0 0 19 22"};

module.exports = ShopCart;

ShopCart.default = ShopCart;
